module.exports = __webpack_public_path__ + "img/o_4.442fc0b5.png";